export default "__VITE_ASSET__JOhfb4HA__"